define('home/views/UserChannelsView',[
    'underscore',
    'backbone-marionette',

    'home/mixins/withSubviews',
    'home/mixins/withEmailVerificationAlert',
    'home/views/ForumCardCollectionView',
    'home/views/ProfileFollowingCommunitiesEmptyView',

    'home/templates/userChannels',
], function (
    _,
    Marionette,

    withSubviews,
    withEmailVerificationAlert,
    ForumCardCollectionView,
    ProfileFollowingCommunitiesEmptyView,

    userChannelsTemplate
) {
    'use strict';

    /**
     * A view that shows the channels special to the given user; created, moderated,
     * or followed by.
     * Expects a UserProfile model
     */
    var UserChannelsView = Marionette.ItemView.extend({
        template: userChannelsTemplate,
        templateHelpers: function () {
            return {
                hideManagedChannels: this.shouldHideManagedChannels(),
            };
        },

        regions: {
            managedChannelsRegion: '[data-role=managed-channels]',
            followedChannelsRegion: '[data-role=followed-channels]',
        },

        initialize: function () {
            // Show/hide the managed channels section based on whether or not the collection is empty
            this.listenTo(this.model.managedChannels.items, 'reset add', function () {
                this.$('[data-role=managed-channels-wrapper]').toggleClass('hidden', this.shouldHideManagedChannels());
            });
        },

        shouldHideManagedChannels: function () {
            return this.model.managedChannels.items.length === 0;
        },

        onRender: function () {
            this.activateRegion(this.managedChannelsRegion, _.partial(this.createChannelsView, this.model.managedChannels));
            this.activateRegion(this.followedChannelsRegion, _.partial(this.createFollowedChannelsView, this.model.followedChannels));
        },

        // Adds additional interactions/visuals for the following channels feed that are
        // not necessary for the managed channels feed.
        createFollowedChannelsView: function (channelFeed) {
            return this.createChannelsView(channelFeed, {
                infiniteScroll: true,
                emptyView: ProfileFollowingCommunitiesEmptyView,
            });
        },

        // Creates a basic view to list channels in the given feed.
        createChannelsView: function (channelFeed, options) {
            return new ForumCardCollectionView(_.extend({
                user: this.model.user,
                model: channelFeed,
                collection: channelFeed.items,
            }, options));
        },
    });

    withSubviews.call(UserChannelsView.prototype);
    withEmailVerificationAlert.call(UserChannelsView.prototype);

    return UserChannelsView;
});

